import Vue from 'vue'
import Vuex from 'vuex'
import { logout, getUserInfo } from '@/api/api'
import permission from './modules/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    HOST: 'http://127.0.0.1:8066',
    userInfo: null,
    token: localStorage.getItem('user_token') || ''
  },
  getters: {
    getUserInfo: state => state.userInfo,
    getToken: state => state.token,
    isLoggedIn: state => !!state.token
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      // 同步到 localStorage
      if (userInfo) {
        localStorage.setItem('user_info', JSON.stringify(userInfo))
      } else {
        localStorage.removeItem('user_info')
      }
    },
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('user_token', token)
      } else {
        localStorage.removeItem('user_token')
      }
    },
    CLEAR_USER_INFO(state) {
      state.userInfo = null
      state.token = ''
      localStorage.removeItem('user_info')
      localStorage.removeItem('user_token')
      localStorage.removeItem('userId')
    }
  },
  actions: {
    // 获取用户信息
    async fetchUserInfo({ commit }) {
      try {
        const res = await getUserInfo()
        if (res.code === 1000 && res.success) {
          commit('SET_USER_INFO', res.data)
          return res.data
        } else {
          throw new Error(res.message || '获取用户信息失败')
        }
      } catch (error) {
        commit('CLEAR_USER_INFO')
        throw error
      }
    },
    // 设置 token
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    // 退出登录
    logout({ commit, dispatch }) {
      return new Promise(resolve => {
        logout().then(res => {
          commit('CLEAR_USER_INFO')
          dispatch('permission/clearPermissions')
        }).catch(() => {
          commit('CLEAR_USER_INFO')
          dispatch('permission/clearPermissions')
        }).finally(() => {
          resolve()
        })
      })
    },
    // 清除用户信息
    clearUserInfo({ commit, dispatch }) {
      commit('CLEAR_USER_INFO')
      dispatch('permission/clearPermissions')
    }
  },
  modules: {
    permission
  }
})

